import { render, staticRenderFns } from "./EgStockAvailability.vue?vue&type=template&id=0d7c1063"
import script from "./EgStockAvailability.vue?vue&type=script&lang=ts"
export * from "./EgStockAvailability.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports